import script from "./InstitutionList.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstitutionList.vue?vue&type=script&lang=ts&setup=true"

export default script